import { CustomLayers } from "ags/names";
import Layers from "slotworks/graphics/layers/layers";
import Scene from "slotworks/graphics/layers/scene";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contract";
import { LLCustomLayers } from "names";

export default class CGMenucontentPaytableTransition extends AbstractSceneTransition {

    private layers: Layers[] = [
        Layers.MatrixContent,
        Layers.MatrixBackground,
        Layers.MatrixForeground,
        Layers.SymbolAnimations,
        Layers.SmartButton,
        Layers.BetBar,
        Layers.Footer,
        Layers.Header,
        Layers.Custom.get(CustomLayers.FIREWORKS),
        Layers.Custom.get(CustomLayers.JACKPOTS),
        Layers.Custom.get(LLCustomLayers.MONEY_CHARGE_BONUS_SYMBOLS),
        Layers.Custom.get(LLCustomLayers.HOLD_AND_SPIN_BORDER),
        Layers.Custom.get(LLCustomLayers.LOGOS),
        Layers.Custom.get(LLCustomLayers.FIRE)
    ];

    private backgroundScene: Scene;

    public in(): Contract<void> {

        return Contract.wrap(() => {
            this.layers.forEach((layer: Layers) => {
                if (layer) {
                    layer.container.renderable = false;
                    layer.container.interactiveChildren = false;
                }
            });

            this.backgroundScene = Layers.Background.getCurrentScene();

            Layers.Background.setScene("paytable").execute();
        });
    }

    public out(): Contract<void> {
        return Contract.wrap(() => {
            this.layers.forEach((layer: Layers) => {
                if (layer) {
                    layer.container.renderable = true;
                    layer.container.interactiveChildren = true;
                }
            });

            Layers.Background.setScene(this.backgroundScene).execute();
        });
    }
}
